export const LOGIN_COMPANY_DISPLAY_NAME =
  process.env.REACT_APP_LOGIN_COMPANY_DISPLAY_NAME || 'Vasantham Concrete';

const LOGIN_COMPANY_MATCH_TEXT =
  process.env.REACT_APP_LOGIN_COMPANY_NAME || 'vasantham';

export function resolveLoginCompany(companyList) {
  const activeCompanies = (companyList || []).filter((company) => company.status);
  if (!activeCompanies.length) {
    return null;
  }

  const configuredCompanyId = (process.env.REACT_APP_LOGIN_COMPANY_ID || '').trim();
  if (configuredCompanyId) {
    const companyById = activeCompanies.find(
      (company) => String(company.id) === configuredCompanyId,
    );
    if (companyById) {
      return companyById;
    }
  }

  const needle = LOGIN_COMPANY_MATCH_TEXT.toLowerCase();
  const displayName = LOGIN_COMPANY_DISPLAY_NAME.toLowerCase();
  const companyByName = activeCompanies.find((company) => {
    const name = (company.name || '').toLowerCase();
    const alias = (company.alias || '').toLowerCase();
    return (
      name.includes(needle)
      || alias.includes(needle)
      || name.includes(displayName)
      || alias.includes(displayName)
    );
  });
  if (companyByName) {
    return companyByName;
  }

  return activeCompanies[0] || null;
}

export function getCompanyMediaUrl(apiBaseUrl, mediaPath) {
  if (!mediaPath) {
    return '';
  }
  if (/^https?:\/\//i.test(mediaPath)) {
    return mediaPath;
  }
  const origin = apiBaseUrl.replace(/\/api\/?$/, '');
  return `${origin}${mediaPath.startsWith('/') ? '' : '/'}${mediaPath}`;
}
